"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserRole = exports.removeUserScope = exports.addUserScope = exports.fetchGroupOwnerUsers = exports.fetchUsersByRole = exports.fetchCurrentUser = exports.fetchUsers = void 0;
var config_1 = require("../../config");
var ELEMENT_SCOPE_PREFIX = 'elements.';
var isStringArray = function (value) {
    return Array.isArray(value) && value.every(function (item) { return typeof item === 'string'; });
};
var toElementScope = function (scope) {
    var normalizedScope = scope.trim();
    if (normalizedScope.length === 0) {
        return normalizedScope;
    }
    return normalizedScope.startsWith(ELEMENT_SCOPE_PREFIX)
        ? normalizedScope
        : "" + ELEMENT_SCOPE_PREFIX + normalizedScope;
};
var readScopeGrants = function (payload) {
    if (isStringArray(payload.scopeGrants)) {
        return payload.scopeGrants;
    }
    if (isStringArray(payload.scopes)) {
        return payload.scopes;
    }
    if (isStringArray(payload.permissions)) {
        return payload.permissions;
    }
    return [];
};
exports.fetchUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
    var apiGet, result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                apiGet = config_1.getApiGet();
                return [4 /*yield*/, apiGet('/ai/users')];
            case 1:
                result = _a.sent();
                return [2 /*return*/, Array.isArray(result) ? result : []];
            case 2:
                error_1 = _a.sent();
                console.warn('[rbac] users fetch failed:', error_1.message);
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.fetchCurrentUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var apiGet, result, currentUser, scopeGrants, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                apiGet = config_1.getApiGet();
                return [4 /*yield*/, apiGet('/ai/users/current')];
            case 1:
                result = _a.sent();
                if (!result) {
                    return [2 /*return*/, null];
                }
                currentUser = result;
                scopeGrants = readScopeGrants(currentUser);
                return [2 /*return*/, __assign(__assign({}, currentUser), { scopeGrants: scopeGrants, permissions: scopeGrants })];
            case 2:
                error_2 = _a.sent();
                console.warn('[rbac] current user fetch failed:', error_2.message);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
var mapUsersToOptions = function (users) {
    var seen = new Set();
    var mapped = users
        .filter(function (user) { return user.isActive !== false; })
        .map(function (user) { return ({
        id: user.objectId,
        displayName: (typeof user.displayName === 'string' && user.displayName.trim().length > 0
            ? user.displayName.trim()
            : undefined) ||
            (typeof user.email === 'string' && user.email.trim().length > 0
                ? user.email.trim()
                : undefined) ||
            user.objectId,
        permissions: readScopeGrants(user),
    }); })
        .filter(function (user) {
        if (!user.id || seen.has(user.id)) {
            return false;
        }
        seen.add(user.id);
        return true;
    })
        .sort(function (a, b) { return a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }); });
    return mapped;
};
exports.fetchUsersByRole = function (roleFilters) { return __awaiter(void 0, void 0, void 0, function () {
    var users, normalizedNameFilters, idFilters, filtered;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.fetchUsers()];
            case 1:
                users = _a.sent();
                normalizedNameFilters = new Set();
                idFilters = new Set();
                roleFilters.forEach(function (filter) {
                    if (typeof filter === 'number') {
                        idFilters.add(filter);
                        return;
                    }
                    normalizedNameFilters.add(filter.trim().toLowerCase());
                });
                filtered = users.filter(function (user) {
                    var role = user.role;
                    if (!role) {
                        return false;
                    }
                    if (idFilters.has(role.id)) {
                        return true;
                    }
                    return normalizedNameFilters.has(role.name.toLowerCase());
                });
                return [2 /*return*/, mapUsersToOptions(filtered)];
        }
    });
}); };
exports.fetchGroupOwnerUsers = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, exports.fetchUsersByRole([3, 'group-owner'])];
}); }); };
exports.addUserScope = function (userObjectId, permission) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost("/ai/users/" + encodeURIComponent(userObjectId) + "/scope-grants", {
                        scope: toElementScope(permission),
                    })];
            case 1:
                result = (_a.sent());
                return [2 /*return*/, readScopeGrants(result)];
        }
    });
}); };
exports.removeUserScope = function (userObjectId, permission) { return __awaiter(void 0, void 0, void 0, function () {
    var apiDelete, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiDelete = config_1.getApiDelete();
                return [4 /*yield*/, apiDelete("/ai/users/" + encodeURIComponent(userObjectId) + "/scope-grants", {
                        scope: toElementScope(permission),
                    })];
            case 1:
                result = (_a.sent());
                return [2 /*return*/, readScopeGrants(result)];
        }
    });
}); };
exports.updateUserRole = function (userObjectId, role) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPatch, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPatch = config_1.getApiPatch();
                return [4 /*yield*/, apiPatch("/ai/users/" + encodeURIComponent(userObjectId), {
                        role: role,
                    })];
            case 1:
                result = (_a.sent());
                return [2 /*return*/, result];
        }
    });
}); };
